import { useTranslations } from 'next-intl';

import Image from '@/app/components/Image';
import Motion from '@/app/components/Motion';

import {
  PopHighlightsRingTooltip,
  type PopHighlightsRingTooltipProps,
} from './PopHighlightsRingTooltip';

export interface PopHighlightsRingProps {
  readonly tooltip: PopHighlightsRingTooltipProps | undefined;
}

export function PopHighlightsRing({
  tooltip,
}: PopHighlightsRingProps): JSX.Element {
  const t = useTranslations();
  const glowHeight = 231;
  const glowWidth = 355;
  const ringHeight = 527;
  const ringWidth = 585;
  return (
    <Motion
      initial={{ opacity: 0, scale: 1.1 }}
      transition={{ delay: 0.3, duration: 1 }}
      viewport={{ once: true }}
      whileInView={{ opacity: 1, scale: 1 }}
    >
      <div className="flex justify-center">
        <div className="relative flex-initial">
          <Image
            alt={t('pop_highlights_horizon_silver_ring_alt')}
            height={ringHeight}
            src="blue-sky/pop/pop_highlights_ring_trimmed.png"
            width={ringWidth}
          />
          {tooltip && (
            <PopHighlightsRingTooltip key={tooltip.content} {...tooltip} />
          )}
          <Motion
            className="absolute mix-blend-overlay"
            data-cy="pop_highlights_ring_glow"
            initial={{ opacity: 0 }}
            style={{
              bottom: `${(21 / ringWidth) * 100}%`,
              maxHeight: ringHeight,
              maxWidth: ringWidth,
              right: `${(106 / ringWidth) * 100}%`,
              width: `${(glowWidth / ringHeight) * 100}%`,
            }}
            transition={{ delay: 1.4, duration: 0.75 }}
            viewport={{ once: true }}
            whileInView={{ opacity: 1 }}
          >
            <Image
              alt=""
              aria-hidden="true"
              className="block size-full"
              draggable={false}
              height={glowHeight}
              src="blue-sky/pop/pop_highlights_ring_glow.png"
              width={glowWidth}
            />
          </Motion>
        </div>
      </div>
    </Motion>
  );
}
